import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent {
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() mostrarInput: boolean = false;
  motivo: string = '';

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  // Método para confirmar
  onConfirm() {
    this.confirm.emit();
  }

  // Método para cancelar
  onCancel() {
    this.cancel.emit();
  }
}
